import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import { AnalyticsSettingsModal } from "./AnalyticsSettingsModal";
import { AnalyticsViewDetails } from "../AnalyticsViewDetails";
import { Connection } from "../Connection";
import analyticsLogo from "../../AccountDetails/analytics-logo.png";

export const GoogleAnalyticsSettings = (props) => {
    const location = useLocation();
    const userDetails = useSelector(s => s.login.userDetails);
    const [dialogOpen, setDialogOpen] = useState(false);

    const ws = props.currentWorkspace;
    const settings = ws.analyticsSettings || {};
    const isOwner = ws.ownerName === userDetails.username;

    // Connecting an account leaves the app for Google's consent screen; this flag on the way back is
    // what reopens the dialog where the user left off.
    useEffect(() => {
        if (location.search.includes("selectAnalyticsViewOpen=true")) setDialogOpen(true);
    }, [location.search]);

    return (
        <Connection
            label="Google Analytics"
            icon={analyticsLogo}
            isOwner={isOwner}
            isConnected={Boolean(settings.tokenName)}
            busyWith={props.busyWith}
            imported={props.imported}
            emptyText="No Google Analytics connection configured."
            details={<AnalyticsViewDetails settings={settings} />}
            onEdit={() => setDialogOpen(true)}
            onRemove={() => props.setAnalyticsSettings(null)}
            dialog={
                <AnalyticsSettingsModal
                    workspace={ws}
                    userIsWorkspaceOwner={isOwner}
                    analyticsSettings={settings}
                    workspaceNumber={ws.seqNumber}
                    setAnalyticsSettings={props.setAnalyticsSettings}
                    workspaceWebsiteUrl={ws.websiteUrl}
                    userDetails={userDetails}
                    isOpen={dialogOpen}
                    toggle={() => setDialogOpen(open => !open)}
                />
            }
        />
    );
};
